<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원팝업</span>
            <span class="txt">센터의 다양한 정보와 소식을 앱으로 빠르게 전달 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-setting-btn" @click="categoryPop = true"></button>
                </div>
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/setting/member/pop/list">목록</router-link>
                    <button v-if="!isModify && isWriteAuth" class="com-btn blue" @click="onClickRegist">등록</button>
                    <button v-else-if="isWriteAuth" class="com-btn blue" @click="onClickModify">수정</button>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td class="no-padding">
                            <select-form
                                :select-data="['카테고리를 선택하세요.', ...categoryTypeList]"
                                :select-value="['', ...categoryTypeValueList]"
                                :selected-value="categoryId"
                                class="full"
                                @update:set="(val) => (categoryId = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td>
                            <input ref="refTitle" v-model="title" class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <!-- <th>내용</th> -->
                        <th>URL</th>
                        <td>
                            <input v-model="editorData" class="w100p" type="text" />
                            <!-- <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor> -->
                        </td>
                    </tr>
                    <tr>
                        <th>파일 첨부</th>
                        <td class="no-padding">
                            <div class="file-box">
                                <input v-model="fileName" class="design-input" readonly type="text" />
                                <b-form-file
                                    id="file1"
                                    accept=".jpg, .png, .gif"
                                    plain
                                    @change="handleFile"
                                />
                                <label for="file1">찾아보기</label>
                            </div>
                            <div class="preview-box">
                                <button
                                    class="com-btn"
                                    @click="noticePop = true; noticePopText = true;"
                                >
                                    미리보기
                                </button>
                                <p class="txt">
                                    ※ 이미지는 660px*660px 정사각형 사이즈와 최대 100MB 용량으로 최적화되어 있습니다.
                                </p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-bottom-check flex">
                <div class="com-check">
                    <input id="check-1-1" v-model="showPeriodYn" name="check-1" type="checkbox" />
                    <label for="check-1-1">
                        <strong>노출기간설정</strong>
                        설정한 기간동안 팝업이 어플리케이션에 노출됩니다.
                    </label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="showStartDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="showEndDate" @update="endDateUpdate"></single-calendar>
                </div>
            </div>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/setting/member/pop/list">목록</router-link>
                    <button v-if="!isModify && isWriteAuth" class="com-btn blue" @click="onClickRegist">등록</button>
                    <button v-else-if="isWriteAuth" class="com-btn blue" @click="onClickModify">수정</button>
                </div>
            </div>
        </div>

        <!-- 설정 팝업 -->
        <div v-show="categoryPop" class="layer-pop category-setting">
            <div class="view-content">
                <button class="close" @click="categoryPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <loading-spinner v-if="isLoading"></loading-spinner>
                    <div class="del-box">
                        <div class="input-cnt flex-col">
                            <div
                                v-for="(category, index) in categoryList.infos"
                                v-if="category.deleteYn === false"
                                class="line"
                            >
                                <input :key="index" ref="categoryArray" v-model="category.name" type="text" />
                                <button class="com-btn" @click="deleteCategory(category.id, index)">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="addCategory">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 10개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onCancle">취소</button>
                        <button v-if="isWriteAuth" class="com-btn blue" @click="saveCategory">저장</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 센터 검색 팝업 -->
        <!--        <div class="layer-pop square-type" v-show="centerPop">-->
        <!--            <div class="view-content">-->
        <!--                <div class="scroll-area com-scroll-y">-->
        <!--                    <span class="sub-title">센터 검색 결과</span>-->
        <!--                    <div class="top-search-area">-->
        <!--                        <div class="right">-->
        <!--                            <input type="text" class="w220" placeholder="센터명" v-model="centerNameKeyword" v-on:keyup.enter="onEventSearchCenter" ref="refCenterName">-->
        <!--                            <button class="com-btn" @click="onEventSearchCenter">검색</button>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    <table class="com-table">-->
        <!--                        <colgroup>-->
        <!--                            <col style="width: 70px;">-->
        <!--                            <col style="width: 280px;">-->
        <!--                            <col style="width: 160px;">-->
        <!--                        </colgroup>-->
        <!--                        <thead>-->
        <!--                            <tr>-->
        <!--                                <th></th>-->
        <!--                                <th>센터명</th>-->
        <!--                                <th>연락처</th>-->
        <!--                            </tr>-->
        <!--                        </thead>-->
        <!--                        <tbody>-->
        <!--                            <tr v-for="center in searchCenterList" :key="center.id">-->
        <!--                                <td>-->
        <!--                                    <div class="com-radio">-->
        <!--                                        <input type="radio" name="radio-pop" :id="`radio-pop-${center.id}`" :value="center"-->
        <!--                                               v-model="selectedCenter">-->
        <!--                                        <label :for="`radio-pop-${center.id}`"></label>-->
        <!--                                    </div>-->
        <!--                                </td>-->
        <!--                                <td>{{ center.centerName }}</td>-->
        <!--                                <td>{{ center.telNo | phoneNumberFilter }}</td>-->
        <!--                            </tr>-->
        <!--                            <tr v-if="searchCenterList.length === 0">-->
        <!--                                <td colspan="100">등록된 내용이 없습니다.</td>-->
        <!--                            </tr>-->
        <!--                        </tbody>-->
        <!--                    </table>-->
        <!--                    <b-pagination  aria-controls="my-table" align="center" first-class="first" prev-class="prev" next-class="next" last-class="last"-->
        <!--                                   v-model="centerPagingInfo.page" :total-rows="centerPagingInfo.totalItems" :per-page="centerPagingInfo.limit" @change="handlerPagenation($event,'center')"></b-pagination>-->
        <!--                    <div class="bottom-btn">-->
        <!--                        <button class="com-btn" @click="cancelCenterPopup">취소</button>-->
        <!--                        <button class="com-btn blue" @click="centerPick">선택</button>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->

        <!-- 팝업 미리 보기 : 이미지 -->
        <div v-show="noticePop" class="layer-pop notice-pop">
            <div class="view-content">
                <div class="top-area">
                    <button class="close-btn" @click="noticePop = false"></button>
                </div>

                <div class="view-area">
                    <!-- 이미지 일시 -->
                    <img :src="base64data || (this.fetchFileList.length && this.fetchFileList[0].fileUrl)" alt="" />
                    <!-- //이미지 일시 -->
                </div>
                <!-- <div class="bottom-area-pop">
                    <a href="#" class="detail-link">자세히보기</a>
                    <div class="daily-check">
                        <div class="com-check">
                            <input type="checkbox" name="week-check" id="week-check-1">
                            <label for="week-check-1">일주일간 띄우지 않음</label>
                        </div>
                        <button class="check-btn">오늘 그만보기</button>
                        <button class="close" @click="noticePop = false">닫기</button>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateSpace } from '@/assets/js/validation.js';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor.js';
import SimpleUpload from '../../../assets/js/ckeditor/simpleUpload';

export default {
    name: 'SettingMemberPopEdit',
    components: { LoadingSpinner },
    computed: {
        isModify() {
            return this.noticeId != null;
        },
        isWriteAuth() {
            const { getters } = this.$store;
            return (
                getters['auth/isCareAdmin'] ||
                getters['auth/isSystemAdmin'] ||
                getters['auth/isCenterAdmin'] ||
                getters['auth/isCenterStaff']
            );
        },
        isReadAuth() {
            const { getters } = this.$store;
            return this.isWriteAuth || getters['auth/isCustomer'];
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        showPeriodYn(newValue) {
            if (newValue === false) {
                this.showStartDate = '';
                this.showEndDate = '';
            }
        },
        showStartDate(newValue) {
            if (newValue) {
                this.showPeriodYn = true;
            }
        },
        showEndDate(newValue) {
            if (newValue) {
                this.showPeriodYn = true;
            }
        },
    },
    mounted() {
        this.targets[0].centerId = parseInt(this.cId);
        this.fetchCategory();
        if (this.isModify) {
            // 수정이면 팝업 상세 가져옴
            this.fetchPopupDetail();
        }
    },
    data() {
        return {
            categoryPop: false,
            centerPop: false,
            noticePop: false,
            noticePopText: false,

            isLoading: false,
            noticeId: this.$route.params.id, // id가 있으면 수정
            categoryList: {
                infos: [],
            },

            categoryTypeList: [],
            categoryTypeValueList: [],

            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },

            categoryId: '',
            title: null,
            content: null,
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data
            showPeriodYn: false,

            base64data: '', // 업로드 파일 base64 임시 저장
            fetchFileList: [], // 수정화면에서 기존에 첨부되어 있던 파일 정보
            fileName: '', // 새로 업로드할 파일
            deleteFileIds: [], // 삭제되는 첨부파일 fileId 배열

            selectedCategoryId: '',

            taskType: 'F', // 케어어드민 : F, 센터어드민 : C

            showStartDate: '',
            showEndDate: '',

            // centerNameKeyword: '',
            // searchCenterList: [], // 센터명으로 검색된 센터 목록
            // selectedCenter: {}, // 센터 검색을 통해 선택한 센터 정보
            // targetCenter: {},// 선택한 센터

            targets: [
                {
                    centerId: '',
                },
            ],
        };
    },
    methods: {
        // 카테고리 가져오기
        async fetchCategory() {
            try {
                this.isLoading = true;
                const { data } = await this.getCategoryList();
                console.log('===> Success Loading categoryList : ', data);
                data.forEach((category) => {
                    // 받아온 data의 key 값을 필요한 값으로만 재배열
                    const tempCategory = {
                        id: category.b_id,
                        largeType: category.b_l_type_cd,
                        smallType: category.b_s_type_cd,
                        name: category.b_namee,
                        deleteYn: category.b_del_yn,
                    };
                    this.categoryList.infos.push(tempCategory);
                });
                this.categoryList.infos.forEach((category) => {
                    // 카테고리 리스트를 select-form 카테고리 목록에 push
                    this.categoryTypeList.push(category.name);
                    this.categoryTypeValueList.push(String(category.id));
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 카테고리 목록 조회 API
        getCategoryList() {
            return api.get('/admin/api/board/category', {
                params: {
                    largeType: 'C', // 케어어드민 : F, 센터어드민 : C
                    smallType: 'P', // 팝업 : P, 게시판 : B, 자주하는질문 : F, 일대일문의 : I, 메뉴얼 : M
                },
            });
        },

        // 팝업 등록 API
        postPopup(data) {
            return api.post('/admin/api/board/popup', data);
        },

        // 팝업 수정 API
        putPopup(id, data) {
            return api.put(`/admin/api/board/popup/${id}`, data);
        },

        // 등록, 수정 validation
        validateValues() {
            if (this.title === '' || this.title === null) {
                this.$nextTick(function () {
                    this.$refs.refTitle.focus();
                });
                return '제목을 입력하세요.';
            }
            // else if(this.editorData === '' || this.editorData === null) {
            //     return '내용을 입력하세요.';
            // }
            else if (this.showPeriodYn === true && (this.showStartDate === '' || this.showEndDate === '')) {
                return '날짜를 선택하세요.';
            } else if (this.showStartDate > this.showEndDate) {
                return '시작일이 종료일보다 빠릅니다.';
            }
        },

        // 팝업 수정
        async onClickModify() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }
            this.isLoading = true;
            try {
                if (this.uploadFiles.length) {
                    // uploadFiles에 값이 있으면 파일을 수정한것, 기존 파일은 delete 하는것으로 간주
                    this.fetchFileList.forEach((file) => {
                        this.deleteFileIds.push(parseInt(file.fileId));
                    });
                }

                const updateData = {
                    centerId: this.cId,
                    categoryId: this.categoryId,
                    title: this.title,
                    content: this.editorData,
                    taskType: this.taskType, // 케어어드민 : F, 센터어드민 : C
                    showType: 'B', // 센터와회원전체노출 : T, 센터전체노출 : C, 센터개별노출 : A, 회원전체노출 : B, 해당사항없음 : -
                    showPeriodYn: this.showPeriodYn,
                    showStartDate: this.showStartDate,
                    showEndDate: this.showEndDate,
                    deleteFileIds: this.deleteFileIds,
                    targets: this.targets,
                };

                if (this.showPeriodYn === false) {
                    delete updateData.showStartDate;
                    delete updateData.showEndDate;
                }
                if (this.uploadFiles.length > 0) {
                    // 첨부 파일이 있으면 data에 insert
                    updateData.uploadFiles = this.uploadFiles;
                }

                if (this.categoryId === '') {
                    delete updateData.categoryId;
                }

                const { data } = await this.putPopup(this.noticeId, updateData);
                alert('수정 되었습니다.');
                console.log('===> Success Update Popup : ', data);
                this.$router.push({ name: 'SettingMemberPopList' });
            } catch (error) {
                alert('수정 실패했습니다.');
                console.log(error);
            }
        },

        // 팝업 등록
        async onClickRegist() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }
            this.isLoading = true;
            try {
                const createData = {
                    centerId: this.cId,
                    categoryId: this.categoryId,
                    title: this.title,
                    content: this.editorData,
                    deleteFileIds: this.deleteFileIds,
                    taskType: this.taskType, // 케어어드민 : F, 센터어드민 : C
                    showType: 'B', // 센터와회원전체노출 : T, 센터전체노출 : C, 센터개별노출 : A, 회원전체노출 : B, 해당사항없음 : -
                    showPeriodYn: this.showPeriodYn,
                    showStartDate: this.showStartDate,
                    showEndDate: this.showEndDate,
                    uploadFiles: this.uploadFiles,
                    targets: this.targets,
                };
                if (this.showPeriodYn === false) {
                    delete createData.showStartDate;
                    delete createData.showEndDate;
                }
                if (this.uploadFiles.length === 0) {
                    delete createData.uploadFiles;
                }
                if (this.categoryId === '') {
                    delete createData.categoryId;
                }

                const { data } = await this.postPopup(createData);
                alert('등록 되었습니다.');
                console.log('===> Success Create Popup : ', data);
                this.isLoading = false;
                this.$router.push({ name: 'SettingMemberPopList' });
            } catch (error) {
                alert('등록 실패했습니다.');
                console.log(error);
            }
        },

        // 팝업 상세 첨부 파일 리스트 API
        getPopupDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 팝업 상세 Fetch
        async fetchPopupDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.getPopupDetail(this.noticeId);
                this.categoryId = String(data.categoryId === null ? '' : data.categoryId);
                this.title = data.title;
                this.taskType = data.taskType;
                this.showPeriodYn = data.showPeriodYn;
                this.showStartDate = data.showStartDate;
                this.showEndDate = data.showEndDate;
                this.editorData = data.content;
                if (this.showPeriodYn === false) {
                    this.showStartDate = '';
                    this.showEndDate = '';
                }

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const {data: fileData} = await this.getPopupDetailFileGroup(data.fileGroupId);
                    this.fileName = fileData[0].name;
                    this.fetchFileList.push(...fileData);
                }

                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 팝업 상세 API
        getPopupDetail(id) {
            return api.get(`/admin/api/board/popup/${id}`);
        },

        // File 핸들러
        async handleFile(e) {
            try {
                const file = e.target.files[0];
                let base64data = await this.readFileAsync(file);
                this.base64data = base64data; // 이미지 미리보기
                base64data = base64data.split(',')[1];
                if (base64data === undefined) {
                    alert('비어있는 파일은 첨부할 수 없습니다.');
                    return;
                }
                const fileInfo = {
                    filename: file.name,
                    mimetype: file.type,
                    base64data,
                };

                this.fileName = fileInfo.filename;
                this.uploadFiles[0] = fileInfo;
            } catch (error) {
                alert('파일 첨부 중 오류가 발생했습니다.');
            }
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        // 카테고리 아이템 추가
        addCategory() {
            if (this.categoryList.infos.length > 10) {
                alert('카테고리는 최대 10개까지만 추가 가능합니다.');
                return;
            }
            this.categoryList.infos.push({
                largeType: 'C',
                smallType: 'P',
                name: '',
                deleteYn: false,
            });
        },

        // 카테고리 아이템 삭제
        deleteCategory(categoryId, index) {
            console.log(categoryId, index);
            if (categoryId === undefined) {
                this.categoryList.infos.splice(index, 1);
            } else if (categoryId) {
                this.categoryList.infos[index].deleteYn = !this.categoryList.infos[index].deleteYn;
            }
        },

        // 카테고리 저장 API
        postSaveCatetory() {
            return api.post('/admin/api/board/category', this.categoryList);
        },

        // 카테고리 저장
        async saveCategory() {
            const validate = this.validateCategoryValues();
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.categoryArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                const { data } = await this.postSaveCatetory();
                console.log('===> Success Category create : ', data);
                alert('카테고리를 저장했습니다.');
                this.initCategoryValue();
                await this.fetchCategory();
            } catch (error) {
                alert('카테고리 저장 실패했습니다.');
                console.log(error);
            }
        },

        // 카테고리 validation
        validateCategoryValues() {
            const msg = '카테고리명을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.categoryArray.some((category, index) => {
                if (!validateSpace(category.value) || category.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return { result, resultIndex, msg };
        },

        // 취소 버튼 클릭 이벤트
        onCancle() {
            this.initCategoryValue();
            this.fetchCategory();
            this.categoryId = this.selectedCategoryId;
            this.popShowType = this.selectedPopShowType;
        },

        // 카테고리 저장전 관련 변수 초기화
        initCategoryValue() {
            this.categoryPop = false;
            this.categoryList = { infos: [] };
            this.categoryTypeList = [];
            this.categoryTypeValueList = [];
            this.selectedCategoryId = this.categoryId; // 이전에 선택했던 카테고리 임시 저장
            this.selectedPopShowType = this.popShowType; // 이전에 선택했던 노출대상 임시 저장
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.showStartDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.showEndDate = val;
        },
    },
};
</script>
<style lang="scss"></style>
